import React from "react";
import {
  FiShield,
  FiClock,
  FiDollarSign,
  FiTruck,
  FiDownload,
  FiFileText,
  FiStar,
} from "react-icons/fi";
import { BiSolidOffer } from "react-icons/bi";
import { MdSecurity, MdPayment } from "react-icons/md";
import { BsPhone, BsTablet, BsWatch } from "react-icons/bs";

const WhyTap2Cash = ({ isDarkMode }) => {
  const features = [
    {
      icon: <FiStar className="text-2xl" />,
      title: "Maximum Value & Complete Safety",
      description:
        "Get the best price for old phones, tablets, and smartwatches with fair and transparent pricing. Enjoy factory-grade data wipe for 100% security.",
    },
    {
      icon: <MdPayment className="text-2xl" />,
      title: "Payment Before Pickup",
      description:
        "We ensure instant cash for old phones before collection, giving you complete trust and confidence in the process.",
    },
    {
      icon: <BiSolidOffer className="text-2xl" />,
      title: "Honest Deals – No Hidden Charges",
      description:
        "No service fees, platform charges, or hidden deductions. Our offers are transparent and fair.",
    },
    {
      icon: <FiTruck className="text-2xl" />,
      title: "Free Doorstep Pickup",
      description:
        "Enjoy a hassle-free mobile resale experience with zero pickup fees—sell your device from the comfort of your home.",
    },
    {
      icon: <FiDownload className="text-2xl" />,
      title: "No App Download Required",
      description:
        "Sell your old tablet or smartwatch without downloading an app, keeping your device storage free for memories that matter!",
    },
    {
      icon: <FiFileText className="text-2xl" />,
      title: "Valid sell Receipt",
      description:
        "Get a proper sale invoice for your records, ensuring a secure and legally documented transaction.",
    },
  ];

  return (
    <section className="mb-8">
      {/* Section Header */}
      <div className="text-center mb-4">
        <h2 className="text-lg md:text-xl font-bold text-green-600">
          Why Tap2Cash?
        </h2>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {features.map((feature, index) => (
          <div
            key={index}
            className={`p-4 rounded-xl transition-all hover:shadow-md ${
              isDarkMode
                ? "bg-gray-800 hover:bg-gray-750"
                : "bg-white hover:shadow-lg border border-gray-100"
            }`}
          >
            <div className="flex items-start gap-3">
              {/* Green Icon Container */}
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
                  isDarkMode
                    ? "bg-green-600/20 text-green-400"
                    : "bg-green-100 text-green-600"
                }`}
              >
                {feature.icon}
              </div>

              <div className="flex-1">
                {/* Title */}
                <h3
                  className={`text-sm font-semibold mb-1 ${
                    isDarkMode ? "text-white" : "text-gray-800"
                  }`}
                >
                  {feature.title}
                </h3>

                {/* Description */}
                <p
                  className={`text-xs leading-relaxed ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  {feature.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyTap2Cash;
